import { configureStore } from "@reduxjs/toolkit";

import envelope from "../../../commons/libs/externals/envelope";
import { createUnhandledActionMiddleware, getSliceReducers } from "../../commons/store/middlewares/unhandled-action";

import { createMobileTrackingMiddleware } from "./middlewares/tracking";
import { mobileSlices } from "./registered-slices";

function createMobileStore({
  trackingMiddleware
}: {
  trackingMiddleware: ReturnType<typeof createMobileTrackingMiddleware>;
}) {
  return configureStore({
    devTools: !envelope.isProductionBuild,
    reducer: getSliceReducers(mobileSlices),
    middleware: getDefaultMiddleware => {
      /**
       * We don't need to serialize actions in our own special context, so we can disable it.
       * But we know we could do it, but then we would have to ignore the checks especially for toasts and modals,
       * which contain BrowserSpriteIcons and callbacks.
       * @see https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state
       * @see https://redux.js.org/faq/actions#why-should-type-be-a-string-why-should-my-action-types-be-constants
       * @see https://redux.js.org/style-guide/#do-not-put-non-serializable-values-in-state-or-actions
       */
      const defaultMiddleware = getDefaultMiddleware({ serializableCheck: false });

      return envelope.isProductionBuild
        ? defaultMiddleware.concat(trackingMiddleware)
        : defaultMiddleware.concat(createUnhandledActionMiddleware(mobileSlices), trackingMiddleware);
    }
  });
}

export default createMobileStore;
